import gql from 'graphql-tag';

export const UpdateProfileAlert = gql`
  mutation UpdateProfileAlert(
    $Active: Boolean!
    $ProfileAlertId: ID!
    $ProfileId: String!
    $TriggerAlert: Boolean!
  ) {
    UpdateProfileAlert(
      Input: {
        Active: $Active
        ProfileAlertId: $ProfileAlertId
        ProfileId: $ProfileId
        TriggerAlert: $TriggerAlert
      }
    ) {
      AcknowledeAt
      Active
      AlertType
      CreatedAt
      ProfileAlertId
      ProfileId
      TaxYear
      UpdatedAt
    }
  }
`;
